module.exports = __webpack_public_path__ + "img/onColor.139f25f9.svg";